import { type ComponentPropsWithRef } from "react";
import { CommandItem } from "@/components/molecules/command";
import { DROPDOWN_PANEL_COMMAND_ITEM_CLASS } from "@/components/molecules/dropdownPanel/dropdownPanel";
import { cn } from "@/lib/utils";

export const DropdownPanelCommandItem = ({
  className,
  ref,
  ...props
}: ComponentPropsWithRef<typeof CommandItem>) => (
  <CommandItem
    ref={ref}
    className={cn(DROPDOWN_PANEL_COMMAND_ITEM_CLASS, className)}
    {...props}
  />
);
